import { types } from "mobx-state-tree";

export const SAPSelect = types.model("SAPSelect", {
  value: types.string,
  label: types.string,
  Name: types.string,
  Id: types.string,
});
